"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletePackagingSet = void 0;
const common_1 = require("../../common");
class DeletePackagingSet extends common_1.UpdateAction {
}
exports.DeletePackagingSet = DeletePackagingSet;
//# sourceMappingURL=delete-packaging-set.action.js.map